import t from"styled-components";import{theme as e}from"../../../../../theme.js";const i=t.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: ${e.spacing*12}px;
  .buttons {
    display: flex;
    gap: ${e.spacing*6}px;
    align-items: center;
  }
`,n=t.span`
  font-size: 14px;
  line-height: 24px;
  color: ${e.colors.gray[400]};
`;export{i as Container,n as Date};
